import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const ViewWACampaignLogsModal = React.lazy(
  () => import("./view-wa-campaign-logs.modal"),
);

const ViewWACampaignLogs: iModalProps<
  typeof ViewWACampaignLogsModal,
  {
    campaignId: string;
    logType: string;
    query?: any;
  }
> = {
  name: "wa-marketing-campaign-logs",
  component: GenerateModalWithSuspense(ViewWACampaignLogsModal),
};

export default ViewWACampaignLogs;
